import React, { useContext, useEffect, useState } from "react";

import TransaccionalContext from "../context/TransaccionalContext";

import { Paper, useMediaQuery } from "@mui/material";

import {
  ContainerCompanyLogo,
  DetalleTransaccionesCliente,
  DetalleOptionsMenu,
} from ".";

import CabeceraCuentaCredito from "../components/CabeceraCuentaCredito";

import { consultarEstadoCredito } from "../services/transaccionalService";
import { useResolutionScreen } from "../hooks/useResolutionScreen";

import SpinnerLoadSrx from "app/modules/shared/components/SpinnerLoadSrx";

const DetalleTransaccional = ({ datosBusqueda, setDatosBusqueda }) => {
  const { informacionTransaccional, setInformacionTransaccional } =
    useContext(TransaccionalContext);

  const [cabenceraTransaccional, setCabenceraTransaccional] = useState({
    idCuenta: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isColapse, setIsColapse] = useState(false);

  const { alturaResolucion } = useResolutionScreen();

  const showDropdownSearch = useMediaQuery("(max-width:1181px)");

  useEffect(() => {
    console.log(datosBusqueda);

    const getCabeceraTsx = async () => {
      try {
        const respuestaCabeceraTsx = await consultarEstadoCredito(
          datosBusqueda.identificacion,
          datosBusqueda.idGrupo
        );

        /*  console.log(respuestaCabeceraTsx); */

        if (respuestaCabeceraTsx.state) {
          setCabenceraTransaccional(respuestaCabeceraTsx.data);

          setInformacionTransaccional((args) => ({
            ...args,
            identificacion: respuestaCabeceraTsx?.data?.identificacion,
            idCliente: respuestaCabeceraTsx?.data?.idCliente,
            idGrupo: respuestaCabeceraTsx?.data?.idGrupo,
            informacionTransaccional: respuestaCabeceraTsx?.data,
          }));

          setIsLoading(false);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    getCabeceraTsx();
  }, [informacionTransaccional.updateValidacionPago]);

  useEffect(() => {
    const actualizarTamañoPantalla = () => {
      if (showDropdownSearch) {
        setIsColapse(true);
      } else {
        setIsColapse(false);
      }
    };
    actualizarTamañoPantalla();
  }, [showDropdownSearch]);

  const handleColapse = () => {
    setIsColapse(!isColapse);
  };

  if (isLoading) {
    return <SpinnerLoadSrx />;
  }

  if (
    cabenceraTransaccional.idCuenta <= 0 ||
    cabenceraTransaccional.idCuenta === null
  ) {
    return (
      <Paper
        sx={{ width: "70%", padding: "2rem", borderRadius: "25px" }}
        elevation={3}
      >
        Cliente no posee cuenta.!!
      </Paper>
    );
  }

  return (
    <main
      className={`${
        isColapse
          ? "movimientoCliente-container-colapse"
          : "movimientoCliente-container"
      }`}
    >
      <ContainerCompanyLogo />

      <CabeceraCuentaCredito
        cabenceraTransaccional={cabenceraTransaccional}
        datosBusqueda={datosBusqueda}
        updateCabecera={informacionTransaccional.updateValidacionPago}
      />

      <DetalleOptionsMenu
        isColapse={isColapse}
        handleColapse={handleColapse}
        alturaResolucion={alturaResolucion}
      />

      <DetalleTransaccionesCliente
        cabenceraTransaccional={cabenceraTransaccional}
        datosBusqueda={datosBusqueda}
        alturaResolucion={alturaResolucion}
      />
    </main>
  );
};

export default DetalleTransaccional;
